import { combineTokens } from '@utils/css';

const overlayTokens = combineTokens("--card-overlay", {
  width: "31rem"
});
const wrapperCls = "_j0jwob3xum";
const imageAndMetaWrapperCls = "_j0ji135btwi";
const imageCls = "_j0ji16g3tr6";
const metaItemCls = "_j0jm6tt008";
const titleCls = "_j0jt17hoe2g";
const descriptionCls = "_j0jd1lmw31a";
const buttonsWrapper = "_j0jbvqw7s0";
const buttonCls = "_j0jbdkij4f";

export { buttonCls, buttonsWrapper, descriptionCls, imageAndMetaWrapperCls, imageCls, metaItemCls, overlayTokens, titleCls, wrapperCls };
import "./atom.card-overlay.style.linaria.module.css";
//# sourceMappingURL=atom.card-overlay.style.js.map
